import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { DiscountPolicy } from 'src/features/discountPolicies/utils/types';

const RESOURCE = '/discounts/discount-policy/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    service_plans?: string[];
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<DiscountPolicy>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_DISCOUNT_POLICIES_RESOURCE, useQueryHook as useListDiscountPolicies };
